import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { productTypeList } from "../API";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const token = useSelector((state: any) => state?.token)
  const navigate = useNavigate()

  const [categoryLi, setCategoryLi] = React.useState<any>([])
  const handleLoad = () => {
    productTypeList()
      .then((res) => {
        setCategoryLi(res.data)
        // .filter((item: any) =>
        //   item.cfgName &&
        //   item.cfgName !== "其他" &&
        //   item.cfgName &&
        //   item.cfgName !== "全部"
        // )
      })
      .catch((err) => {
        console.log(err)
      })
  }
  useEffect(() => {
    handleLoad()
  }, [])

  return (
    <div className="bg-[#181512]">
      <div className=" w-[906px] mx-auto h5:w-[100%] h5:px-16 box-border">
        <div className="flex pt-[30px] pb-[40px]">
          <img src={require("../assets/image/footer-logo.png")} className="w-[158px] h5:w-[107px]" alt="" />
          <div className="flex-1 flex items-center justify-end">
            <a href="https://www.facebook.com/scanteak?fref=ts&_ga=2.261257038.215742908.1767082552-1404405351.1766565616"
              target="_blank" rel="noopener noreferrer">
              <img src={require('../assets/image/facebook.png')} alt="" className="w-[23px]" />
            </a>
            <a href="https://www.youtube.com/channel/UC0pk9mq2UyHpntp-atOHHhQ"
              target="_blank" rel="noopener noreferrer">
              <img src={require('../assets/image/youtube.png')} alt="" className="w-[23px] mx-16" />
            </a>
            <a href="https://www.instagram.com/scanteaktw/"
              target="_blank" rel="noopener noreferrer">
              <img src={require('../assets/image/instagram.png')} alt="" className="w-[25px]" />
            </a>
          </div>
        </div>
        <div className="flex pb-20">
          <div className="flex flex-1 h5:block">
            <div className="flex flex-1 h5:pb-[40px]">
              <div className="flex-1">
                <div className="text-[18px] text-[#ffffff]">商品分類</div>
                <div className="bg-[#645b54] w-[25px] h-[2px] mt-[15px] mb-[20px]"></div> 
                {
                  categoryLi && categoryLi.slice(0, 4).map((item: any) => (
                    <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" key={item?.id}
                      onClick={() => {
                        navigate('/category' + '?id=' + item?.id)
                        window.location.reload()
                      }
                      }
                    >{item?.cfgName}</div>
                  ))
                } 
              </div>
              <div className="flex-1">
                <div className="text-[18px] text-[#ffffff] opacity-0">商品分類</div>
                <div className="bg-[#645b54] w-[25px] h-[2px] mt-[15px] mb-[20px] opacity-0"></div>
                {
                  categoryLi && categoryLi.slice(4).map((item: any) => (
                    <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" key={item?.id}
                      onClick={() => {
                        navigate('/category' + '?id=' + item?.id)
                        window.location.reload()
                      }
                      }
                    >{item?.cfgName}</div>
                  ))
                } 
              </div>
            </div>
            <div className="flex flex-1">
              <div className=" flex-1">
                <div className="text-[18px] text-[#ffffff]">關於詩肯</div>
                <div className="bg-[#645b54] w-[25px] h-[2px] mt-[15px] mb-[20px]"></div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => navigate('/about/whyUs')}>關於詩肯</div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => navigate('/about/whyUs#part-1')}>品牌文化</div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => navigate('/about/whyUs#part-2')}>為何選擇詩肯</div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => navigate('/about/history')}>歷史和歷程碑</div> 
              </div>
              <div className=" flex-1">
                <div className="text-[18px] text-[#ffffff]">其他連結</div>
                <div className="bg-[#645b54] w-[25px] h-[2px] mt-[15px] mb-[20px]"></div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => {
                  if (token) {
                    window.open('https://tawk.to/chat/6998a0174d62fa1c365da542/1jhu32na5', '_blank')
                  } else {
                    navigate('/login')
                  }
                }}>聯絡我們</div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => navigate('/faq')}>常見問題</div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => navigate('/aboutShipping')}>線上購物須知</div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => navigate('/privacy')}>個人資料保護政策</div>
                <div className="text-[16px] text-[#e0e0e0] pb-4 cursor-pointer" onClick={() => navigate('/dataProtection')}>隱私權保護政策</div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-[12px] text-[#e0e0e0] py-[30px]">© Scanteak 2026. All Rights Reserved.</div>
      </div>
    </div>
  );
};

export default ComponentName;
